export enum AgentType {
  AI = 0,
  Human = 1,
  Both = 2,
}
